export const headerCellStyle = {
    backgroundColor: '#f9fafb',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    borderBottom: '1px solid #e5e7eb',
    color: '#374151',
    fontSize: '13px',
    fontWeight: 600,
} as const;

export const rowStyle = {
    borderBottom: '1px solid #f3f4f6',
} as const;

export const commonTableStyles = {
    header: headerCellStyle,
    row: rowStyle,
} as const;

export const surveyDetailsTableStyles = {
    header: headerCellStyle,
    row: rowStyle,
    table: {
        borderCollapse: 'separate' as const,
        borderSpacing: 0,
    },
} as const;
